import React from "react";
import { useTranslation } from "react-i18next";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import { getImage } from "../../services/ImageService";

export function SolutionPageSelection(props) {
    const { t } = useTranslation();

    return (
        <div className="group h-full flex items-center items-center cursor-pointer select-none">
            <div className="bg-[#368E66] flex md:px-12 text-[14px] font-bold text-white hover:text-primary-accent-hovered h-full w-full flex items-center z-20">
                {t("solutions")}
                <div className="w-5 pl-2 mt-1">
                    <img
                        src={getImage("menu_down_white")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute flex-col bg-[#3A9E70] top-24 z-10 w-max select-none overflow-y-auto max-h-[56rem]">
                <AnchorLink
                    content={t("timber-purchases")}
                    target="/#timber-purchases"
                    className="[&>a]:justify-start h-24 hover:bg-primary-accent-normal hover:!text-white"
                />
                <AnchorLink
                    content={t("forest-management")}
                    target="/#forest-management"
                    className="[&>a]:justify-start h-24 hover:bg-primary-accent-normal hover:!text-white"
                />
                <AnchorLink
                    content={t("damage-inventory")}
                    target="/#damage-inventory"
                    className="[&>a]:justify-start h-24 hover:bg-primary-accent-normal hover:!text-white"
                />
            </div>
        </div>
    );
}
